import { useGetSetting } from 'api/settings'
import { getThemeParam } from 'utils/query-params'
import { Theme, ThemeEnum } from 'types/setting'

export const useThemePreference = (): Theme => {
  const { setting } = useGetSetting()
  return getThemeParam() ?? setting?.theme ?? ThemeEnum.Auto
}
